import { Injectable } from '@angular/core';
import { CussService } from '@services/cuss.service';
import { DeviceInt, DeviceReponseInt } from '@app/interfaces/device.interface';
import { BarcodeReadResult } from '@app/interfaces/barcode-data.interface';
import { deviceIds, Device } from 'src/embross-device-manager';
import { sanitizePnrInput, validatePNR } from '@utils/index';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BarcodeDeviceService implements DeviceInt {
  device: Device;
  listen$: Subject<BarcodeReadResult> = new Subject<BarcodeReadResult>();
  isComplete = false;
  timeoutId = undefined;

  constructor(private cussService: CussService) {
    this.setDevice();
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  listen(): Observable<BarcodeReadResult> {
    if (this.isComplete) {
      this.listen$ = new Subject<BarcodeReadResult>();
    }
    return this.listen$.asObservable();
  }

  disable(): void {
    if (this.device) {
      this.device.disable();
      this.device.OnDeviceEvent = null;
    }
  }

  enable(): void {
    this.setDevice();
    if (this.device) {
      try {
        this.device.OnDeviceEvent = this.callback;
        this.device.enable();
      } catch (error) {
        console.error('[Error enable barcode]', error);
      }
    }
  }

  readDummy() {
    this.timeoutId = setTimeout(() => {
      this.listen$.next({ pnr: 'SUHFDZ', lastName: null });
    }, 1500);
  }

  callback = (event: DeviceReponseInt) => {
    switch (event.key) {
      case 'parsedBarcodeData': {
        let pnr = null;
        let lastName: string | null = null;
        let isValid = false;
        const response = event.value;
        const data = JSON.parse(response);

        if (data) {
          lastName = data.passengerLastName?.trim() || null;

          if (data.legs) {
            const { legs } = data;
            const rawPnr = legs ? legs[0]?.pnr : null;
            pnr = sanitizePnrInput(rawPnr);
            if (pnr && validatePNR(pnr)) {
              isValid = true;
            }
          }
        }

        if (isValid) {
          this.listen$.next({ pnr, lastName });
        } else {
          this.listen$.error({ message: 'Invalid barcode: PNR validation failed' });
        }

        break;
      }
      case 'barcodeRemoved':
        this.listen$.complete();
        this.isComplete = true;
        break;
    }
  };

  private setDevice() {
    if (this.cussService.getDeviceManager()) {
      this.device = this.cussService.getDeviceManager().getDevice(deviceIds.BARCODE_READER);
    }
  }
}
